var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 107.5 107.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fddf64;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.15,26.76h-28.8c-7.04,0-12.75,5.71-12.75,12.75v28.8c0,7.04,5.71,12.75,12.75,12.75h28.8c7.04,0,12.75-5.71,12.75-12.75v-28.8c0-7.04-5.71-12.75-12.75-12.75ZM53.75,71.19c-9.54,0-17.27-7.73-17.27-17.27s7.73-17.27,17.27-17.27,17.27,7.73,17.27,17.27-7.73,17.27-17.27,17.27ZM71.6,40.01c-2.22,0-4.02-1.8-4.02-4.02s1.8-4.02,4.02-4.02,4.02,1.8,4.02,4.02-1.8,4.02-4.02,4.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.75,42.72c-6.18,0-11.19,5.01-11.19,11.2s5.01,11.2,11.19,11.2,11.2-5.01,11.2-11.2-5.01-11.2-11.2-11.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.75,0C24.11,0,0,24.11,0,53.75s24.11,53.75,53.75,53.75,53.75-24.11,53.75-53.75S83.39,0,53.75,0ZM87.03,67.82c0,10.61-8.6,19.21-19.21,19.21h-28.14c-10.61,0-19.21-8.6-19.21-19.21v-28.14c0-10.61,8.6-19.21,19.21-19.21h28.14c10.61,0,19.21,8.6,19.21,19.21v28.14Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.ccc0b57e0cfa3ba769fafba34544edf3.svg";
export { ForwardRef as ReactComponent };